import { useDisclosure } from '@mantine/hooks';
import { Flex, Space, TextInput } from '@mantine/core';
import { useForm, yupResolver } from '@mantine/form';
import { AutomatedAuditLoader, Button, Select } from '@common/components';
import { createClientOrganization, currentAction, getClientOrganizations, getOwnCompanies, resetOrganisationState, useAppDispatch, useAppSelector } from 'src/store';
import { shallowEqual } from 'react-redux';
import { useAlert, useFormFocus } from '@common/hooks';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
// import { industryOptions } from 'src/constants/industryOptions';
import * as yup from 'yup';
import { validationPattern } from '@common/helpers';


type formValue = {
  // industryField: string;
  name: string;
}
function CreateOrganizationComp({
  onCloseFun,
  entity,
  entities

}: {
  onCloseFun: () => void;
  entity: string;
  entities: string;
}) {
  const [t] = useTranslation('organization');
  const { showAlert } = useAlert();
  const {
    createOrganization,
    loadingCreateOrganization,
    createOrganizationError

  } = useAppSelector((state) => state.organization, shallowEqual);

  const {
    data
  } = useAppSelector((state) => state.user, shallowEqual);
  const validationFormSchema = yup.object().shape({
    name: validationPattern.companyName,
    // industryField: validationPattern.industryField,
  });
  const [opened, { open, close }] = useDisclosure(false);
  const form = useForm({
    initialValues: {
      //industryField: "Agriculture",
      name: ""
    },
    validate: yupResolver(validationFormSchema),
  });
  const { setNeedFocus } = useFormFocus({ formErrors: form.errors });

  // Open handler that stops event propagation
  const handleOpen = (e: any) => {
    e.stopPropagation();  // Stops the click event from reaching the dropdown
    open();
  };

  const dispatch = useAppDispatch();
  async function handleFormSubmit(values: formValue) {
    const { name } = values;


    await dispatch(createClientOrganization({
      tenant_id: data?.tenantId,
      name,

      submitCallback: () => {
        showAlert({
          id: 'create' + entity,
          title: `Create ${entity}`,
          message: `${entity} has been created`,
          variant: 'success',
          autoClose: 3000,
        });
        dispatch(resetOrganisationState());
        dispatch(getClientOrganizations({ tenantId: data?.tenantId }));
        form.reset();
        onCloseFun();
      },
      errorCallback: (error: string) => {
        showAlert({
          id: 'error',
          title: 'Enable To Create' + entity,
          message: error,
          variant: 'error',
          autoClose: 3000,
        });
        setNeedFocus(true)
        dispatch(resetOrganisationState());
        form.setFieldError('name', error)
      }


    }))

  }

  return (
    <div className={styles.warraper}>
      <form
        className={classNames(styles['form-container'])}
        onSubmit={form.onSubmit((values) => {

          handleFormSubmit(values)
        })}>
        <TextInput
          id='New_Company_Name'
          autoFocus
          className={classNames(styles['grow'])}
          label={"Company Name"}
          placeholder={'New Company Name'}
          {...form.getInputProps('name')}
        />
        {/* <Space h={'md'} /> */}
        {/* <Select
          width='100%'
          maxWidth='100%'
          placeholder={`Select Industry`}
          className={styles.dropdown}
          data={industryOptions}
          withIcon
          aria-label="Industry, use the arrow keys on your keyboard to navigate between options. Press the enter key to select an option"
          
          {...form.getInputProps('industryField')}
      /> */}
        <Space h={'md'} />
        {/* <Select
            // label="Enter Category"
            width='100%'
            placeholder="Enter category"
            data={['React', 'Angular', 'Vue', 'Svelte']}
            searchable
            value={''}
            onChange={()=>{}}
          /> */}
        <Flex gap={"md"} mt={'md'} justify={"end"} >
          <Button type={'submit'}
            ariaLabel='Submit name of company'
            loading={loadingCreateOrganization}
          >
            Submit
            {
              loadingCreateOrganization && <AutomatedAuditLoader />
            }
          </Button>
          <Button
            ariaLabel='Cancel creation of company'
            color={'dark-green'}
            onClick={() => {
              form.reset();
              onCloseFun();
            }}>
            Cancel
          </Button>
        </Flex>
      </form>
    </div>
  );
}

export default CreateOrganizationComp;
